<div class="w-100 ">
  <h2 class="text-center my-4">Are you sure you want to delete ?</h2>
<div class="d-flex justify-content-center my-5">
  <button class="btn btn-light me-2" type="button" (click)="cancel()">Cancel</button>
  <button class="btn btn-danger" type="button" (click)="onConfirm()">Delete</button>
</div>

</div>
